import { all } from "redux-saga/effects";
import { donViTinhSaga } from "./donViTinhSaga";
import { hinhThucThanhToanSaga } from "./hinhThucThanhToanSaga";
import { coSoSaga } from "./coSoSaga";
import { heSaga } from "./heSaga";
import { khoiSaga } from "./khoiSaga";
import { lopSaga } from "./lopSaga";
import { namHocSaga } from "./namHocSaga";
import { khoSaga } from "./khoSaga";
import { nhapKhoSaga } from "./nhapKhoSaga";
import { tienThuaHocSinhSaga } from "./tienThuaHocSinhSaga";

export default function* categorySaga() {
  yield all([
    donViTinhSaga(),
    hinhThucThanhToanSaga(),
    coSoSaga(),
    heSaga(),
    khoiSaga(),
    lopSaga(),
    namHocSaga(),
    khoSaga(),
    nhapKhoSaga(),
    tienThuaHocSinhSaga()
  ]);
}